import { WSEmptyState } from "@wingspanhq/fe-component-library";
import React, { useMemo } from "react";
import { WorkLogPayeeTabFilterStatus } from "./TableWorkLogsPayeeView/filters/types";
import { WorkLogPayerTabFilterStatus } from "./TableWorkLogsPayerView/filters/types";

/**
 * Empty state shown when filters return no results
 */
export const WorkLogsFilterEmptyState: React.FC = () => (
  <WSEmptyState
    py="3XL"
    hasBorder
    bgColor="gray"
    type="search"
    title="No results found"
    description="Try adjusting your search or filter to find what you're looking for."
  />
);

/**
 * Empty state for payee work logs based on status tab
 */
export const WorkLogsPayeeEmptyState: React.FC<{
  status?: WorkLogPayeeTabFilterStatus;
}> = ({ status }) => {
  const { title, description } = useMemo(() => {
    switch (status) {
      case WorkLogPayeeTabFilterStatus.Rejected:
        return {
          title: "No rejected work logs",
          description: "Work logs rejected by clients will appear here."
        };
      case WorkLogPayeeTabFilterStatus.InProgress:
        return {
          title: "No in-progress work logs",
          description:
            "Draft work logs and those returned for corrections will appear here."
        };
      case WorkLogPayeeTabFilterStatus.Submitted:
        return {
          title: "No submitted work logs",
          description:
            "Work logs you've submitted for client approval will appear here."
        };
      case WorkLogPayeeTabFilterStatus.Approved:
        return {
          title: "No approved work logs",
          description: "Work logs approved by clients will appear here."
        };
      default:
        return {
          title: "No work logs",
          description: "Create a new work log to get started."
        };
    }
  }, [status]);

  return (
    <WSEmptyState
      py="3XL"
      hasBorder
      bgColor="gray"
      type="tasks"
      title={title}
      description={description}
    />
  );
};

/**
 * Empty state for payer work logs based on status tab
 */
export const WorkLogsPayerEmptyState: React.FC<{
  status?: WorkLogPayerTabFilterStatus;
}> = ({ status }) => {
  const { title, description } = useMemo(() => {
    switch (status) {
      case WorkLogPayerTabFilterStatus.Rejected:
        return {
          title: "No rejected work logs",
          description: "Work logs you reject will appear here."
        };
      case WorkLogPayerTabFilterStatus.InProgress:
        return {
          title: "No in-progress work logs",
          description: "Work logs returned for corrections will appear here."
        };
      case WorkLogPayerTabFilterStatus.Approved:
        return {
          title: "No approved work logs",
          description: "Work logs you've approved will appear here."
        };
      case WorkLogPayerTabFilterStatus.ToApprove:
      default:
        return {
          title: "No submitted work logs yet",
          description:
            "Once your contractors submit their work logs, they will appear here."
        };
    }
  }, [status]);

  return (
    <WSEmptyState
      py="3XL"
      hasBorder
      bgColor="gray"
      type="tasks"
      title={title}
      description={description}
    />
  );
};
